import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import Body from "./components/Body/Body";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { CookieSetting } from "cookiesetting-component";
import { useHyperlink } from "./contexts/HyperlinkProvider";
import usePavanData from "./hooks/usePavanData";

// Import the September2023.json file
import december2023 from "./components/Body/december2023.json";
import HeaderNavbar from "./components/Header/Header";
const Footer = lazy(() => import("./components/Footer/Footer.js"));
const Proprty = lazy(() => import("./components/Property/proprty.js"));
const Highlights = lazy(() => import("./components/Highlights/Highlights"));
const Morganlogos = lazy(() => import("./components/Morganlogos/Morganlogos.js"));
const Whysunwest = lazy(() => import("./components/Whysunwest/Morganscan.js"));
const EventComponent = lazy(() => import("./components/Event/Event.js"));
const Testimonial = lazy(() => import("./components/Testimonials/Testimonials.js"));
// const ShiningStar = lazy(() => import("./components/ShiningStar/shiningstar.js"));

function App() {
  const [webinarData, setWebinarData] = useState();
  const [bannerData, setBannerData] = useState();
  const [highlightsData, setHighlightsData] = useState();
  const [propertyData, setPropertyData] = useState();
  const [EventsData, setEventsData] = useState();
  const [formData, setFormData] = useState();
  const [aiBrandingData, setAiBrandingData] = useState();
  const [links, setLinks] = useState(null); // Set initial state as null

  const appVersion = appversion.version;

  const [angelAiLink, setAngelAiLink] = useState('');
  const [angelComLink, setAngelComLink] = useState('');
  const [sunwestLink, setSunWestLink] = useState("");
  const [sunwestLink1, setSunWestLink1] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();
  const pavanData = usePavanData();


 useEffect(() => {
   const processContent = async () => {
     const swLink = await getHyperLink('websites', 'swmc', 0);
     const swLink1 = await getHyperLink('websites', 'swmc', 1);
     const aiLink = await getHyperLink('websites', 'angelai', 0);
     const aiComLink = await getHyperLink('websites','angelai',1);
     const cellLink = await getHyperLink('websites', 'celligence', 1);
     const celliLlcLink = await getHyperLink('websites', 'celligence', 0);
     const pavan = await getHyperLink('profiles', 'pavan', 0);
     setAngelAiLink(aiLink || 'AngelAi');
     setAngelComLink(aiComLink || 'AngelAi.com');
     setSunWestLink(swLink || 'Sun West Mortgage Company, Inc.');
     setSunWestLink1(swLink1 || 'Sun West');
     setCelligenceLink(cellLink || 'Celligence');
     setCelligenceLlcLink(celliLlcLink || 'Celligence LLC');
     setPavanLink(pavan || 'Pavan Agarwal');
   };
   processContent();
 }, [getHyperLink])



  useEffect(() => {
    //Comment out the axios request if we're using the local JSON
    const fetchMorganWebinarJSON = async () => {
      await axios.get(process.env.REACT_APP_DECEMBERJSON_CDN_URL)
        .then(response => {
          const webinarJsonData = response.data;
          setWebinarData(webinarJsonData);
          setBannerData(webinarJsonData.banner);
          setHighlightsData(webinarJsonData.highlights);
          setPropertyData(webinarJsonData.property);
          setEventsData(webinarJsonData.Events);
          setFormData(webinarJsonData.signupform);
        }, error => {
          console.log(error);
        });

    };
    fetchMorganWebinarJSON();

    // Set the data from the local JSON file
    // setWebinarData(december2023);
    // setBannerData(december2023.banner);
    // setHighlightsData(december2023.highlights);
    // setPropertyData(december2023.property);
    // setEventsData(december2023.Events);
    // setFormData(december2023.signupform);
  }, []);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
        // console.log(JSON.stringify(response.data));
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);


  return (
    <div className="bodyContainer">
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true}
        isVerboseMode={false}
        metaFileDirectory={"."}
      >
        <>
          <HeaderNavbar />
          {bannerData ?
            <>
              <Body bannerData={bannerData} formData={formData} links={links} fetchpriority="high" sunwestLink={sunwestLink}/>

              {/* <Suspense fallback={<div />}>
      <LogoSection fetchpriority="low" />
      </Suspense> */}
              <Suspense fallback={<div />}>
                {highlightsData ?
                  <Highlights highlightsData={highlightsData} links={links} />
                  : ""}
              </Suspense>
              <Suspense fallback={<div />}>
                {propertyData ?
                  <Proprty propertyData={propertyData} links={links} />
                  : ""}
              </Suspense>
              <Suspense fallback={<div />}>
              {links ? (
                <EventComponent EventsData={EventsData} links={links} fetchpriority="low" />
                ) : (
                  <Spinner animation="border" role="status">
                  </Spinner>
                )}
              </Suspense>
              <Suspense fallback={<div />}>
                <Testimonial links={links} fetchpriority="low" angelAiLink={angelAiLink}/>
              </Suspense>
              <Suspense fallback={<div />}>
              {links ? (
                <Morganlogos links={links} fetchpriority="low" angelAiLink={angelAiLink} sunwestLink={sunwestLink} />
                ) : (
                  <Spinner animation="border" role="status">
                  </Spinner>
                )}
              </Suspense>
              <Suspense fallback={<div />}>
              {links ? (
                <Whysunwest links={links} fetchpriority="low" angelAiLink={angelAiLink} sunwestLink={sunwestLink} sunwestLink1={sunwestLink1} pavanLink={pavanLink} pavanData={pavanData} />
                ) : (
                  <Spinner animation="border" role="status">
                  </Spinner>
                )}
              </Suspense>
              <Suspense fallback={<div />}>
                <Footer />
              </Suspense>
            </>
            : ""}
             <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
        </>
      </CacheBuster>
    </div>
  );
}

export default App;
